import React from 'react';
import './ThankYouPage.css';

const ThankYouPage = () => {
  return (
    <div className="thank-you-page">
      <div className="thank-you-container">
        <h1>You're All Set!</h1>
        <p>
          Thanks for reaching out! We've received your details and are already on the hunt for your dream place.
        </p>
        <div className="next-steps-section">
          <h2>What Happens Now?</h2>
          <p>
            Our team is now working its magic. We'll personally vet options and send a curated list of places that are a perfect match for you.
          </p>
          <p>
            Stay tuned, we'll be in touch!
          </p>
        </div>
        
        <a href="/" className="back-to-home">Back to Homepage</a>
      </div>
    </div>
  );
};

export default ThankYouPage;